import { IButtonStyles, IIconProps, IIconStyles, ITooltipHostStyles } from "@fluentui/react";
import themeBase from "../theme/themeBase";

export const hostStyles: Partial<ITooltipHostStyles> = {
  root: { display: "inline-block" },
};
export const emojiIcon: IIconProps = { iconName: "PeopleRepeat" };
export const addIcon: IIconProps = { iconName: "CompletedSolid" };
export const IconButtonStyles: Partial<IButtonStyles> = {
  root: { borderRadius: 20, backgroundColor: "#0177D3" },
  icon: { color: "white", fontWeight: "bold" },
  iconHovered: { color: "#000" },
};
export const IconStyles: IIconStyles = {
  root: {
    fontSize: 32,
    color: themeBase.colorsBaseMessaging.SevereWarningIcon,
  },
};
